import _size from 'lodash/size';
import useFastSpringStore from './useFastSpringStore';

export default () => {
  const [{ productsInCart }] = useFastSpringStore()

  return _size(productsInCart)
}
